import React from "react";

import { Box, ThemeSizes } from "../../foundations";
import { Text } from "../../foundations/Typography/Text";

export interface ProgressBarProps {
  value: number;
  showLabel?: boolean;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  showLabel = true
}) => {
  // ensure the value is between 0 and 100
  const clampedValue = Math.max(0, Math.min(100, value));

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "1.5em" as ThemeSizes // matches lineHeight of text
      }}
    >
      <Box
        role="progressbar"
        aria-label={`Progress bar at ${clampedValue}%`}
        aria-valuenow={clampedValue}
        aria-valuemin={0}
        aria-valuemax={100}
        sx={{
          flexGrow: 1,
          borderRadius: "radius-1",
          background: "surface-neutral-tertiary"
        }}
      >
        <Box
          sx={{
            height: "spacing-3",
            width: `${clampedValue}%` as ThemeSizes,
            borderRadius: "radius-1",
            background: "button-surface-filled-enabled"
          }}
        />
      </Box>
      {showLabel && (
        <Text variant="body-2-regular" sx={{ ml: "spacing-4" }}>
          {Math.round(clampedValue)}%
        </Text>
      )}
    </Box>
  );
};
